import React from "react";
import { deviceStore } from "./DeviceStore";
import cropStatusStore from "./CropStatusStore"; 

const StoreContext = React.createContext({ deviceStore, cropStatusStore }); 

export const useStore = () => React.useContext(StoreContext);

const StoreProvider = ({ children }) => (
  <StoreContext.Provider value={{ deviceStore, cropStatusStore }}>
    {children}
  </StoreContext.Provider>
);

export default StoreProvider;
